export const StringIncludesArr = (str: string, search: string[]) => {
    for (let i = 0; i < search.length; i++) {
      if (str.includes(search[i])) {
        return true;
      }
    }
    return false;
  };